import { render } from "./SessionACorrige.vue?vue&type=template&id=ceefffe4&ts=true"
import script from "./SessionACorrige.vue?vue&type=script&lang=ts"
export * from "./SessionACorrige.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__